import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/contact'

const initialState = () => ({
    history: {
        data: [],
        pagination: {}
    }
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        history: state => state.history.data,
        pagination: state => state.history.pagination
    },
    actions: {
        /**
         * @param {{contactId: number, params: {}}} data
         * @returns {Promise<*>}
         */
        listHistory: async ({commit, dispatch}, data) => {
            try {
                const response = await api.listPropertyHistory(data)
                const history = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_CONTACT_PROPERTY_HISTORY, history)
                return history
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        updateProperty: async ({ dispatch }, data) => {
            try {
                const response = await api.updateProperty(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        resetHistory: ({commit}) => commit(mutationTypes.RESET_CONTACT_PROPERTY_HISTORY)
    },
    mutations: {
        [mutationTypes.RESET_CONTACT_PROPERTY_HISTORY]: (state) => Object.assign(state, initialState()),
        [mutationTypes.SET_CONTACT_PROPERTY_HISTORY]: (state, data) => state.history = data
    }
}
